/*
 * @Author: jixiaoyong
 * @Email: jixiaoyong1995@gmail.com
 * @Webiste: https://jixiaoyong.github.io
 * @Date: 24/05/26
 * @LastEditors: jixiaoyong
 * @LastEditTime: 24/05/30
 * @FilePath: /app_list/src/utils/github_api_util.js
 * @Description:  GitHub API 请求封装类
 *
 * Copyright (c) 2024 by jixiaoyong, All Rights Reserved.
 */

async function getGithubConfig(octokit) {
  return await octokit.request(
    "GET /repos/{owner}/{repo}/contents/" + "public/config.json",
    {
      owner: "jixiaoyong",
      repo: "app_list",
      headers: {
        "X-GitHub-Api-Version": "2022-11-28",
      },
    }
  );
}

/**
 * sha Required if you are updating a file. The blob SHA of the file being replaced.
 */
async function updateFileToGithub(octokit, base64Data, commitMsg) {
  const configFile = await getGithubConfig(octokit);
  const sha = configFile.data.sha;

  return await octokit.request(
    "PUT /repos/{owner}/{repo}/contents/" + "public/config.json",
    {
      owner: "jixiaoyong",
      repo: "app_list",
      message: commitMsg,
      sha: sha,
      committer: {
        name: "version updater",
        email: "jixiaoyong1995@gmail.com",
      },
      content: base64Data,
      headers: {
        "X-GitHub-Api-Version": "2022-11-28",
      },
    }
  );
}

export { getGithubConfig, updateFileToGithub };
